export const KnownDialogs = {
  connect: 'connect',
  delegate: 'delegate',
  safeApp: 'safe-app',
  addSelfstake: 'add-selfstake',
  withdraw: 'withdraw',
  editPool: 'edit-pool',
  tabStakeSuccess: 'tab-stake-success',
  tabUnstakeSuccess: 'tab-unstake-success',
  claimSuccess: 'claim-success',
  lsTabsDialog: 'ls-tabs-dialog',
  lsDeprecatedDialog: 'ls-deprecated-dialog',
};

export type KnownDialogs = (typeof KnownDialogs)[keyof typeof KnownDialogs];
